import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useFeature } from '@/lib/useFeature';

/**
 * Renders its children only when the workspace has the module switched on,
 * and otherwise sends the person to their shell's home rather than showing a
 * screen whose every request would be refused.
 */
export function RequireFeature({
  feature,
  fallback,
  children,
}: {
  feature: string;
  fallback: string;
  children: ReactNode;
}) {
  if (!useFeature(feature)) {
    return <Navigate to={fallback} replace />;
  }
  return <>{children}</>;
}
